import React from 'react';
import './PrivacyPageMain.css';

const PrivacyPageMain = (props) => {
  return (
    <div id="content1200">
      <div className="companyTitle">
        <span className="nielsen-navyBlack">개인정보 처리 방침</span>
      </div>
      <div className="txt_box">
        닐슨미디어코리아(유)(이하 '회사')는 <span className="nielsen-red">정보주체</span>의 개인정보를 중요시하며, <span className="nielsen-red">『개인정보보호법』,『정보통신망이용촉진 및정보보호 등에 관한 법률』등 개인정보와 관련된 법령 상의 개인정보보호규정을 준수</span>하고 있습니다.<br />
        당사는 개인정보취급방침을 통하여 정보주체가 제공하는 개인정보가 어떠한 용도와 방식으로 이용되고 있으며, 개인정보보호를 위해 어떠한 조치가 취해지고 있는지 알려드립니다. 만일 개인정보취급방침을 개정하는 경우에는 홈페이지(http://www.buzzword.co.kr) 또는 개별공지를 통하여 안내해 드립니다.<br />
        본 방침은 2020년 7월 1일부터 시행됩니다.
        <div className="privacy_titbox">1. 수집하는 개인정보 항목</div>
				개인정보는 생존하는 개인에 관한 정보로서 실명, 주민등록번호 등의 사항으로 정보주체 개인을 식별할 수 있는 정보(당해 정보만으로는 특정 개인을 식별할 수 없더라도 다른 정보와 용이하게 결합하여 식별할 수 있는 것을 포함)를 말합니다. 당사는 서비스 이용 신청, 서비스 문의 및 안내 등을 위해 아래와 같은 개인정보를 수집하고 있습니다.<br /><br />
        <strong>1) 수집항목</strong><br />
        - 정상적인 서비스 이용 및 안내를 위해 서비스 이용자의 이름, 회사명, 부서명, 전화번호, 이메일, IP주소, MAC어드레스를 수집합니다.<br />
        - 서비스 소개서 신청 시 안내를 위해 이름, 회사명, 이메일, 전화번호를 수집합니다.<br /><br />
        <strong>2) 개인정보 수집방법</strong><br />
        서비스 홈페이지를 통한 수집
        <div className="privacy_titbox">2. 개인정보의 수집 및 이용 목적</div>
          당사는 수집한 개인정보를 다음의 목적을 위해 활용합니다.<br /><br />
        <strong>1) 서비스 이용</strong><br />
				서비스의 정상적인 이용 접근 제한, 키 외부 공유 방지 및 이용 서비스 개선<br /><br />
        <strong>2) 서비스 안내</strong><br />
				서비스 문의, 소개서 신청에 대한 안내 
        <div className="privacy_titbox">3. 개인정보의 보유 및 이용기간</div>
        수집된 개인정보는 원칙적으로, 개인정보 수집 및 이용목적이 달성되고 관계법령에 따른 보존기간이 종료된 후에는 해당 정보를 지체 없이 파기합니다.
        <div className="privacy_titbox">4. 개인정보의 파기 절차 및 방법</div>
        당사는 원칙적으로 개인정보 수집 및 이용목적이 달성된 후에는 해당 정보를 지체 없이 파기합니다. 파기절차 및 방법은 다음과 같습니다.<br /><br />
        1) 정보주체가 입력하신 전자적 파일형태로 저장된 개인정보는 기록을 재생할 수 없는 기술적 방법을 사용하여 삭제합니다.<br />
        2) 종이에 출력 및 저장된 기록물, 인쇄물, 개인정보는 분쇄기로 분쇄하거나 소각을 통하여 파기합니다.
        <div className="privacy_titbox">5. 개인정보 관리(열람,정정,삭제 등)에 관한 사항</div>
        서비스 이용자는 언제든지 등록되어 있는 본인의 개인정보를 열람하거나 정정하실 수 있습니다.<br />
        개인정보 조회, 수정을 위해서는 당사 서비스 페이지에 있는 ‘개인정보수정’을, 가입 해지 시에는 각 사 담당자에게 서면, 전화 또는 이메일 등을 통해 회원탈퇴 절차를 신청하실 수 있습니다.<br />
        또한, 회사는 이용자로부터 탈퇴 의사를 전달 받은 경우 이를 검토하여 즉각적으로 합당한 조치를 취해야 합니다.
        <div className="privacy_titbox">6. 개인정보 자동 수집 장치의 설치, 운영 및 그 거부에 관한 사항</div>
        쿠키(cookie)란 웹 사이트 서버가 이용자의 컴퓨터로 전송하는 소량의 정보이며, 여기에는 방문한 웹 사이트의 정보 및 이용자의 개인정보 등이 담겨있습니다. 이용자는 웹 브라우저의 옵션을 조정함으로써 모든 쿠키를 다 받아들이거나, 회사는 쿠키가 설치될 때 통지를 보내도록 하거나, 아니면 모든 쿠키를 거부할 수 있는 선택권을 가질 수 있습니다. 회사는 쿠키를 운영하고 있지만, 이 쿠키를 통해 수집하는 정보는 Session ID에 한하며, 그 외의 다른 정보는 수집하지 않습니다.
        <div className="privacy_titbox">7. 개인정보의 기술적 물리적 관리적 보호 대책</div>
        당사는 정보주체의 개인정보를 취급함에 있어 개인정보가 분실, 도난, 누출, 변조 또는 훼손되지 않도록 안전성 확보를 위하여 다음과 같은 기술적/물리적/관리적 대책을 강구하고 있습니다.<br /><br />
        <strong>1) 개인정보의 제한적 이용 및 관리(관리적 보호대책)</strong><br />
        정보주체의 개인정보는 서비스 이용 관리와 안내의 목적으로만 사용되며, 내부관리계획/수집/시행, 정기적 직원 교육 등 관리적 조치를 취하고 있습니다.<br /><br />
        <strong>2) 해킹 등에 대비한 대책(기술적, 물리적 보호대책)</strong><br />
        회사는 해킹이나 컴퓨터 바이러스 등에 의해 정보주체의 개인정보가 유출되거나 훼손되는 것을 방지하기 위해 최선을 다하고 있습니다. 침입차단시스템을 이용하여 외부로부터의 무단 접근을 통제하고 있으며, 기타 시스템적으로 보안성을 확보하기 위한 가능한 모든 기술적 장치를 갖추고 있으며, 전산실 및 자료보관실에 대한 접근 통제와 같은 물리적 접근통제 조치를 취하고 있습니다.
        <div className="privacy_titbox">8. 이용자의 권리와 의무</div>
        회사는 서비스 이용 연간계약을 맺은 고객사 회원이 사용하는 아이디와 패스워드는 해당 이용자만 이용하는 것이 원칙입니다. 회사의 고의 또는 과실이 없는 경우, 이용자의 아이디와 패스워드 도용 또는 기타 타인의 사용에 의해 발생된 문제에 대하여회사는 책임지지 않습니다. 어떠한 경우에도 패스워드는 타인에게 알려주지 마시고 로그온 상태에서는 주위의 다른 사람들에게 개인정보가 유출되지 않도록 특별한 주의를 기울여 주시기 바랍니다.
        <div className="privacy_titbox">9. 개인정보에 관한 민원서비스</div>
        당사는 정보 주체의 개인정보를 보호하고 개인정보와 관련한 불만을 처리하기 위하여 아래와 같이 개인정보보호책임자를 지정하고 있습니다.<br />
        <table width="800px" className="tablestyEtc">
          <tr>
            <th width="">개인정보 보호 책임자</th>
            <th width="">개인정보 보호 관리자</th>
          </tr>
          <tr>
            <td>이창렬 (소속: PTOC)</td>
            <td>이혜진 (소속: CS)</td>
          </tr>
          <tr>
            <td>product@koreanclick.com</td>
            <td>buzz@koreanclick.com</td>
          </tr>
        </table>
        기타 개인정보침해에 대한 신고나 상담이 필요하신 경우에는 아래 기관에 문의하시기 바랍니다.
        <table width="800px" className="tablestyEtc">
          <tr>
            <th width="200px">개인분쟁조정위원회</th>
            <td width=""><a href="http://privacy.kisa.or.kr" target="_blank">http://privacy.kisa.or.kr</a> / 1336</td>
          </tr>
          <tr>
            <th width="200px">정보보호마크인증위원회</th>
            <td width=""><a href="http://www.eprivacy.or.kr" target="_blank">http://www.eprivacy.or.kr</a> / 02-580-0533~4</td>
          </tr>
          <tr>
            <th width="200px">대검찰청 인터넷범죄수사센터</th>
            <td width=""><a href="http://www.spo.go.kr" target="_blank">http://www.spo.go.kr</a> / 02-3480-3600</td>
          </tr>
          <tr>
            <th width="200px">경찰청 사이버테러대응센터</th>
            <td width=""><a href="http://www.ctrc.go.kr" target="_blank">http://www.ctrc.go.kr</a> / 02-392-0330</td>
          </tr>
        </table>
        <div className="privacy_titbox">10. 고지의 의무</div>
        현 개인정보취급방침 내용 추가, 삭제 및 수정이 있을 시에는 개정 최소 10일전 발송하는 안내문과 당사 홈페이지(http://www.buzzword.co.kr)를 통해 고지할 것입니다.<br /> 다만, 개인정보의 수집 및 활용, 제3자 제공 등과 같이 이용자 권리의 중요한 변경이 있을 경우에는 최소 30일 전에 고지합니다.<br /><br />
        - 공고일자 : 2020년 06월 30일<br />
        - 시행일자 : 2020년 07월 01일
        </div>
    </div>
  )
}

export default PrivacyPageMain;